import { RelatedTransactionReason } from '@/domain/points/accounting/model/RelatedTransactionReason'
export type RelatedTransactionSign = '+' | '-'
const NEGATIVE_TYPES = ['withdraw', 'withdrawal', 'debit']
export class RelatedTransaction {
  constructor(
    public id: string,
    public type: string,
    public relationship: string,
    public relatedReason?: RelatedTransactionReason | string,
    public platform?: string,
    public amount?: string,
    public dateTime?: Date,
    public description?: string,
    public user?: string,
    public version?: string,
  ) {
  }
  public get sign(): RelatedTransactionSign {
    const rawAmount = Number(this.amount)
    if (NEGATIVE_TYPES.includes((this.type || '').toLowerCase())) {
      return '-'
    }
    return !isNaN(rawAmount) && rawAmount < 0 ? '-' : '+'
  }
  public get absoluteAmount(): number {
    const rawAmount = Number(this.amount)
    return isNaN(rawAmount) ? 0 : Math.abs(rawAmount)
  }
}
